<template>
  <div class="reset-password">
    <ModalKim v-if="showModal" @close="$router.replace({ name: 'login' })" :mood="'playful'" :color="'#4C91FF'">
      <template slot="body">
        <h2>{{ $t('auth.resetPassword.success') }}</h2>
      </template>
    </ModalKim>

    <h1 v-t.preserve="'auth.resetPassword.title'" />
    <h2 v-t.preserve="'auth.resetPassword.subtitle'" />

    <form class="input-container card card--rounded" @submit.prevent="submit" novalidate autocomplete="off">
      <pk-input v-model="password" :placeholder="$t('auth.resetPassword.placeholder.password')" type="password" :error="$v.password.$error" />
      <pk-input v-model="confirmPassword" :placeholder="$t('auth.resetPassword.placeholder.confirmPassword')" type="password" :error="$v.confirmPassword.$error" />
      <error-text :active="!!errorCode || $v.$error">
        <span v-if="errorCode === 400" v-t.preserve="'auth.resetPassword.error.invalidRequest'" />
        <template v-else-if="errorCode === 403">
          {{ $t('auth.resetPassword.error.expiredToken.message') }}
          <a @click.prevent="$emit('changeAuthType', 'forgot', {}, true)" replace>{{ $t('auth.resetPassword.error.expiredToken.CTA') }}</a>
        </template>
        <span v-else-if="!!errorCode" v-t.preserve="'auth.resetPassword.error.generic'" />
        <span v-else-if="$v.password.$error" v-t.preserve="'auth.resetPassword.error.password'" />
        <span v-else-if="$v.confirmPassword.$error" v-t.preserve="'auth.resetPassword.error.passwordsDontMatch'" />
      </error-text>
      <btn flat :loading="loading" submit>{{ $t('auth.resetPassword.reset') }}</btn>
    </form>
  </div>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators'
import peanutbutterAPI from '@/api/peanutbutter'
import formSubmit from '@/js/mixins/formSubmit'
import { strongPassword } from '@/js/validationUtils'

export default {
  name: 'reset-password',
  mixins: [formSubmit('resetPassword')],
  data: () => ({
    token: '',
    password: '',
    confirmPassword: '',
    showModal: false
  }),
  validations: {
    password: { required, strongPassword },
    confirmPassword: { required, sameAs: sameAs('password') }
  },
  methods: {
    async resetPassword() {
      await peanutbutterAPI.resetPassword(this.password, this.token)
      this.showModal = true
      // this.$router.replace({ name: 'login' })
    }
  },
  async created() {
    this.token = this.$route.query.token

    if (!this.token) {
      this.$router.replace({ name: 'login' })
    }
  }
}
</script>
